import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { alertsApi } from '../lib/alertsApi';
import { useAuth } from '../context/AuthContext';

export const AlertNavBadge: React.FC = () => {
  const { user } = useAuth();

  const { data: count = 0 } = useQuery({
    queryKey: ['alert-count'],
    queryFn: () => alertsApi.getAlertCount(user?.organization_id || 'default-org'),
    refetchInterval: 30000, // 30 seconds
    enabled: !!user?.organization_id,
  });

  if (count === 0) return null;

  return (
    <span 
      className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-semibold shadow-lg"
      data-testid="alert-badge"
    >
      {count > 99 ? '99+' : count}
    </span>
  );
};

export default AlertNavBadge;
